import axios from 'axios'
import { helpers } from 'hub-web-lib/dist/index-export'
import { RISK_LEVEL_DIMENSION } from 'js/constants/dashboard-settings'
import { EXPOSURE } from 'js/constants/filter'
import { dispatchRequest } from 'middlewares/ApiHelpers'

const DdosApi = {

    createActivity: async (newActivity) => {
        const body = helpers.cleanEmptyProps(newActivity)
        body.starred = false
        body.archived = false
        body.is_complete = !!newActivity.is_complete
        body.has_findings = !!newActivity.has_findings
        if (!body.start_date) body.start_date = new Date()
        if (!body.end_date) body.end_date = new Date(body.start_date)
        return dispatchRequest(axios.post('/ddos/activity', body)).then(res => res.data)
    },

    updateActivity: async (updatedActivity) => {
        const body = helpers.cleanEmptyProps(updatedActivity)
        body.starred = !!updatedActivity.starred
        body.archived = !!updatedActivity.archived
        body.is_complete = !!updatedActivity.is_complete
        body.has_findings = !!updatedActivity.has_findings
        return dispatchRequest(axios.put('/ddos/activity', body)).then(res => res.data)
    },

    deleteActivity: async (activityId) => {
        return dispatchRequest(axios.delete(`/ddos/activity/${activityId}`)).then(res => res.data)
    },

    getActivity: async (activityId) => {
        return dispatchRequest(axios.get(`/ddos/activity/${activityId}`)).then(res => res.data)
    },

    getAllActivities: async (orgId) => {
        return dispatchRequest(axios.get(`/ddos/org/${orgId}/activity`)).then(res => res.data)
    },

    getPredefinedMetrics: async () => {
        return dispatchRequest(axios.get('/ddos/predefined')).then(res => res.data)
    },

    getActivityMetrics: async (activityId, filter) => {
        if (!filter) filter = {}
        if (filter[RISK_LEVEL_DIMENSION]) filter[EXPOSURE] = filter[RISK_LEVEL_DIMENSION]
        return dispatchRequest(axios.post(`/ddos/activity/${activityId}/metrics`, filter)).then(res => res.data)
    },

    addActivityMetrics: async (activityId, metrics) => {
        return dispatchRequest(axios.post(`/ddos/activity/${activityId}/metrics`, metrics)).then(res => res.data)
    },

    updateActivityMetrics: async (activityId, metrics) => {
        return dispatchRequest(axios.put(`/ddos/activity/${activityId}/metrics`, metrics)).then(res => res.data)
    },

    deleteActivityMetrics: async (activityId) => {
        return dispatchRequest(axios.delete(`/ddos/activity/${activityId}/metrics`)).then(res => res.data)
    },

    deleteActivityMetricsList: async (activityId, metricsList) => {
        return dispatchRequest(axios.delete(`/ddos/activity/${activityId}/metrics`, { data: metricsList })).then(res => res.data)
    },
    getLatestMetrics: async (orgId, test_type) => {
        return dispatchRequest(axios.get(`/ddos/org/${orgId}/last_metrics`, { params: { test_type } })).then(res => res.data)
    },
    postMetricsFile: async (currentOrgId, file, sheetName) => {
        const params = { hard_scan: false }
        if (sheetName) params.sheet = sheetName
        return dispatchRequest(axios.post(`/files/org/${currentOrgId}/ddos_metrics/upload-file`, file, { params })).then(res => res.data)
    },
    getActivityFindings: async (activityId) => {
        return dispatchRequest(axios.get(`/ddos/activity/${activityId}/findings`)).then(res => res.data)
    },
    updateActivityFindings: async (activityId, findings) => {
        return dispatchRequest(axios.put(`/ddos/activity/${activityId}/findings`, findings)).then(res => res.data)
    },
    deleteActivityFindingsList: async (activityId, findingsList) => {
        return dispatchRequest(axios.delete(`/ddos/activity/${activityId}/findings`, { data: findingsList })).then(res => res.data)
    },
    postFindingsFile: async (currentOrgId, file, test_type) => {
        const params = { hard_scan: false, test_type }
        return dispatchRequest(axios.post(`/ddos/org/${currentOrgId}/upload-findings-file`, file, { params })).then(res => res.data)
    },
    downloadMetricsTemplate: async () => {
        return dispatchRequest(axios.get('/files/ddos_metrics/template')).then(res => res.data)
    },
    downloadFindingsTemplate: async () => {
        return dispatchRequest(axios.get('/files/ddos_findings/template')).then(res => res.data)
    },

}
export default DdosApi
